import type { GetAppsResponse } from 'shared/api/containerApi/requests/getApps/getApps.types'

type ContainerApp = GetAppsResponse['data'][number]

export const hasAppAccess = (appId: string, apps: ContainerApp[]): boolean => {
  const app = apps.find(({ app_id }) => String(app_id) === appId)

  return !!app && !app.is_locked
}
